<div class="section-title">
  <div class="section-title__wall"></div>
  <div class="section-title__content">
    <span class="section-title__subtitle">{{subtitle}}</span>
    <span class="section-title__title">{{title}}</span>
  </div>
</div>
